import { useContext, useState } from "react";
import { Tabs } from "antd";
import Courses from "../components/courses/courses";
import SectionTitle from "../components/shared/sectionTitle/sectionTitle";
import { getImage } from "../services/image-utils";
import { UserContext } from "../context/user.context";
import GeneralInformation from "../components/general-information/general-information";
import Reports from "../components/reports/reports";
import MyCoursesSummary from "../components/my-courses-summary/my-courses-summary";
import { useParams } from "react-router-dom";

export default function CoursesRoute({ listType }: { listType: string }) {
  const { id } = useParams();
  const logo = getImage("/assets/SEABC_Logo.png");
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState<string>(`${id ?? "0"}`);

  const tabs = [
    {
      label: "Courses & Workshops List",
      key: "0",
      children: <Courses listType={listType} />,
    },
  ];

  if (user?.firstName && user?.role === "student" && listType === "my") {
    tabs.push({
      label: "My Courses Summary",
      key: "1",
      children: <MyCoursesSummary />,
    });
  }

  if (user?.firstName) {
    tabs.push({
      label: "General Information",
      key: "2",
      children: <GeneralInformation />,
    });
  }

  if (
    user?.firstName &&
    (user?.role === "super-admin" || user?.role === "admin")
  ) {
    tabs.push({
      label: "Reports & Analytics",
      key: "3",
      children: <Reports />,
    });
  }

  return (
    <>
      <SectionTitle>
        <img src={logo} className="max-h-14 mr-3.5" alt="Logo" />
        <h1 className="text-3xl m-0 font-normal">
          Certificate in Structural Engineering Program:{" "}
          {listType === "all" ? "List of courses" : "My Courses"}
        </h1>
      </SectionTitle>
      <Tabs
        type="card"
        items={tabs}
        size="small"
        centered
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
      />
    </>
  );
}
